package xyz.malefic.guptare.model

import kotlinx.serialization.json.Json

val json = Json { ignoreUnknownKeys = true }
